export default {
    pagination: {
        el: '[data-swiper-pagination]',
        type: 'fraction',
    },
};
